// extracted by mini-css-extract-plugin
export default {"container":"NotFound_container__t0McT","button":"NotFound_button__rmHer"};